// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import AuthContext from './AuthContext'

const withAuthContext = Component => {
  const Wrapper = props => (
    <AuthContext.Consumer>
      {authContext => (
        <Component
          authContext={authContext}
          {...props} />
      )}
    </AuthContext.Consumer>
  )

  return Wrapper
}

export default withAuthContext
